<template>
  <button class="item" :class="cssClass" :aria-label="name ? `Click to add ${name} to module` : 'Click to add to module'">
    <div class="item-button-content item-select-tooltip-box">
      <div v-if="assetType"><i :class="getAssetIcon(assetType)"></i></div>
      <div v-else-if="customIcon"><i :class="`fa-duotone fa-solid ${customIcon}`" aria-hidden="true"></i></div>
      <div v-else><i class="fa-duotone fa-bullseye" aria-hidden="true"></i></div>
      <div>
        <div class="asset-name">{{ name }}</div>
        <div class="tag-container">
          <div class="hash-tags" v-for="tag in tags"><i class="fas fa-hashtag" aria-hidden="true"></i> {{ tag }}</div>
        </div>
      </div>
      <div><i class="fas fa-plus-circle add-icon" aria-hidden="true"></i></div>
    </div>
  </button>
</template>

<script>
import AssetIconMixin from '@mixins/asset-icon-mixin';

export default {
  mixins: [AssetIconMixin],

  props: {
    name: String,
    assetType: String,
    customIcon: String,
    cssClass: {
      type: String,
      default: '',
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
button .item-button-content {
  text-align: center;
  align-items: center;
  justify-content: center;
}

button .item-button-content,
button .item-button-content div .tag-container {
  display: flex;
  flex-direction: row;
}

button .item-button-content div .asset-name {
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

button .item-button-content > div {
  flex: 75%;
  overflow: hidden;
}

button .item-button-content > div > i {
  color: var(--kate-background-body);
}

button .item-button-content div:last-child,
button .item-button-content div:first-child {
  flex: 10%;
}

button .item-button-content div .tag-container .hash-tags {
  font-size: 0.75em;
  color: var(--kate-type-primary);
  white-space: nowrap;
}

button .item-button-content div .tag-container {
  overflow-x: hidden;
  gap: 20px;
  max-width: 100%;
}

button .item-button-content div .tag-container .hash-tags i {
  color: var(--kate-warning);
}

.item-select-tooltip-box {
  width: 100%;
}
</style>
